import { IconButton, Input } from '@airbus/components-react';
import { Close, Search } from '@airbus/icons/react';
import { useCallback } from 'react';

export default function MultiHtzInput({
  handleKeyDown,
  handleMultiHtzSearch,
  multiHTZInput,
  setMultiHtzInput,
}) {
  const handleChange = useCallback((e) => {
    const rawValue = e.target.value;
    // Regex: Match any character that is NOT a letter (a-z, A-Z), digit (0-9), hyphen (-), or comma (,)
    const validValue = rawValue.replace(/[^a-zA-Z0-9,-]/g, '');
    setMultiHtzInput(validValue);
  }, []);

  return (
    <div style={{ marginTop: '16px', marginBottom: '10px', display: 'flex' }}>
      <Input
        value={multiHTZInput}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        placeholder='Enter HTZs separated by comma (e.g., A-1234,B-5678)'
        style={{
          flexGrow: 1,
          minWidth: '600px',
          paddingRight: '68px',
        }}
        endAdornment={
          <>
            <IconButton
              variant='ghost'
              size='small'
              onClick={() => setMultiHtzInput('')}
              aria-label='clear input'
            >
              {<Close />}
            </IconButton>

            <IconButton
              variant='ghost'
              size='small'
              onClick={handleMultiHtzSearch}
              aria-label='search multiple HTZ values'
            >
              {<Search />}
            </IconButton>
          </>
        }
      />
    </div>
  );
}
